import { BsStars } from 'react-icons/bs';
import React from 'react';

import { Typography } from '@/components/atoms/Typography';
import { pictureScore } from '@/utils/pictureScore';
import clsx from 'clsx';

export enum PictureScore {
  BAD = 'À Améliorer',
  GOOD = 'Bien',
  EXCELLENT = 'Excellent'
}

export interface PictureScoreLabelProps {
  score: number;
}

export const PictureScoreLabel: React.FC<PictureScoreLabelProps> = ({ score }: PictureScoreLabelProps) => {
  return (
    <>
      <span className="flex gap-1 items-center  py-1 justify-center">
        <BsStars className="text-black" size={16} />
        <Typography variant="h5">Pertinence par IA :</Typography>
      </span>

      <div
        className={clsx(
          pictureScore(score) === PictureScore.BAD && 'bg-red-500 text-white border-red-600',
          pictureScore(score) === PictureScore.GOOD && 'bg-yellow-500 text-white border-yellow-600',
          pictureScore(score) === PictureScore.EXCELLENT && 'bg-emerald-500 text-white border-emerald-600',
          'border-b rounded-b-xl py-0.5 px-2 w-full flex items-center justify-center gap-2'
        )}
      >
        <p className="text-xs">
          {pictureScore(score) === PictureScore.BAD && '⚠️'}
          {pictureScore(score) === PictureScore.GOOD && '✅'}
          {pictureScore(score) === PictureScore.EXCELLENT && '🚀'}
        </p>
        <p className="text-sm">{pictureScore(score)}</p>
      </div>
    </>
  );
};
